import React from 'react'
import { Link } from 'react-router-dom'
import { cn } from 'utils'
import styles from './Footer.module.scss'

const FooterNew = () => {
  const cdn = 'https://kombatlink-assets.azureedge.net/img'
  return (
    <footer className={styles.footer}>
      {/* <div className="container-fluid h-100">
        <div className="row h-100 align-items-center">
          <div className="col-lg-auto col-sm-12">
            <div className="row justify-content-center">
              <a
                target="_blank"
                href="https://www.facebook.com/KombatLink"
                className={cn(styles.footer__icon, styles.footer__iconFacebook)}
                rel="noreferrer"
              />
              <a
                target="_blank"
                href="https://twitter.com/KombatLink"
                className={cn(styles.footer__icon, styles.footer__iconTwitter)}
                rel="noreferrer"
              />
              <a
                target="_blank"
                href="https://www.instagram.com/kombatlink"
                className={cn(styles.footer__icon, styles.footer__iconInstagram)}
                rel="noreferrer"
              />
              <a
                target="_blank"
                href="https://www.twitch.tv/kombatlink"
                className={cn(styles.footer__icon, styles.footer__iconTwitch)}
                rel="noreferrer"
              />
              <a
                target="_blank"
                href="https://discord.gg/dKpG3P3sUB "
                className={cn(styles.footer__icon, styles.footer__iconDiscord)}
                rel="noreferrer"
              />
              <a
                target="_blank"
                href="https://vm.tiktok.com/ZMdGwJDVN/ "
                className={cn(styles.footer__icon, styles.footer__iconTikTok)}
                rel="noreferrer"
              />
            </div>
          </div>
          <div className="col-lg col-sm-12 m-sm-20">
            <div className="row justify-content-center">
              <Link to="/faq" className={styles.footer__link}>
                Guides
              </Link>
              <Link to="/rules" className={styles.footer__link}>
                Rules
              </Link>
              <Link to="/disclaimer" className={styles.footer__link}>
                Disclaimer
              </Link>
            </div>
          </div>
          <div className="col-lg-auto col-sm-12">
            <div className="row justify-content-center">
              <div className={cn(styles.footer__logo, styles.footer__logoVisa)} />
              <div className={cn(styles.footer__logo, styles.footer__logoMastercard)} />
              <div className={cn(styles.footer__logo, styles.footer__logoCrypto)} />
            </div>
          </div>
        </div>
      </div> */}
      <div className="wrapper">
        <div className={`row row-xl-4 row-l-4 row-m-1 flex-m equal-height ${styles.footer_block_wrapper}`}>
          <div className="col-xl-4 col-l-3 col-m-12 d-flex flex-column align-items-center">
            <div className={styles.footer_logo}><a href="index.html"><img src={`${cdn}/footer_logo.png`} alt="logo" /></a></div>
            <div className={styles.footer_social}>
              <ul>
                <li className={styles.fi_1}><a href="https://www.facebook.com/KombatLink" target="_blank"><img src={`${cdn}/fi-1.png`} alt="fi" /></a></li>
                <li className={styles.fi_2}><a href="https://twitter.com/KombatLink" target="_blank"><img src={`${cdn}/fi-2.png`} alt="fi" /></a></li>
                <li className={styles.fi_3}><a href="https://www.instagram.com/kombatlink" target="_blank"><img src={`${cdn}/fi-3.png`} alt="fi" /></a></li>
                <li className={styles.fi_4}><a href="https://www.twitch.tv/kombatlink" target="_blank"><img src={`${cdn}/fi-4.png`} alt="fi" /></a></li>
                <li className={styles.fi_5}><a href="https://discord.gg/dKpG3P3sUB" target="_blank"><img src={`${cdn}/fi-5.png`} alt="fi" /></a></li>
                <li className={styles.fi_6}><a href="https://vm.tiktok.com/ZMdGwJDVN/" target="_blank"><img src={`${cdn}/fi-6.png`} alt="fi" /></a></li>
              </ul>
            </div>
          </div>
          <div className={`col-xl-2 col-l-3 col-m-12 ${styles.footer_links}`}>
            <h2>EXPLORE</h2>
            <ul>
              <li>
                <Link to="/faq">
                  Guides
                </Link>
              </li>
              <li><Link to="/rules">
                Rules
              </Link></li>
              <li><Link to="/disclaimer">
                Disclaimer
              </Link></li>
            </ul>
          </div>
          <div className={`col-xl-3 col-l-3 col-m-12 ${styles.footer_links}`}>
            <h2>Company</h2>
            <ul>
              <li><Link to="/faq/why-choose">
                About Us
                </Link></li>
              <li><Link to="/faq/get-in-touch">
                Contact Us
                </Link></li>
              <li><Link to="/terms-of-service">
                Legal
                </Link></li>
            </ul>
          </div>
          <div className={`col-xl-3 col-l-3 col-m-12 ${styles.footer_links} ${styles.payment}`}>
            <h2>Payment </h2>
            <ul>
              <li><a href="#"><img src={`${cdn}/pi-1.png`} alt="payment" /></a></li>
              <li><a href="#"><img src={`${cdn}/pi-2.png`} alt="payment" /></a></li>
              <li><a href="#"><img src={`${cdn}/pi-3.png`} alt="payment" /></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.copyright_wrap}>
        <div className={styles.wrapper}>
          <p>Copyright © 2022 kombatlink. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default FooterNew
